import { __assign } from 'tslib';
import __vue_component__ from '../HseDropdownMenu/HseDropdownMenuGroup.vue.js';
import Vue from 'vue';

var script = Vue.extend({
    name: 'HseSelectOptionGroup',
    functional: true,
    render: function (h, ctx) {
        var children = ctx.children, data = ctx.data, listeners = ctx.listeners;
        return h(__vue_component__, __assign(__assign({}, data), { on: listeners }), children);
    }
});

export default script;
